import { Component, Input, OnInit } from '@angular/core';
import { setting } from '../../../../../setting';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss']
})
export class SplashComponent implements OnInit {

    @Input() clientSetting: any;
    @Input() showSplashScreen: boolean = false;

    private sectionAuth: any;
    private routerUploadFile: any;

  constructor() { }

  ngOnInit(): void {
     this.routerUploadFile = setting.routeUploadFile;
  }

  backgroundColor(): string {
    if(!this.sectionAuth) {
      this.sectionAuth = this.clientSetting ? JSON.parse(this.clientSetting?.clients_setting_app_auth?.section_header) : null;
    } else if(this.sectionAuth) {
      return `${this.sectionAuth?.background_1}`;
    } else {
      return '';
    }

  }

  avatarClient(): string {
      if(this.clientSetting && !this.sectionAuth) {
      this.sectionAuth = this.clientSetting ? JSON.parse(this.clientSetting?.clients_setting_app_auth?.section_header) : null;
    } else if(this.sectionAuth) {
       return `${this.routerUploadFile}${this.sectionAuth?.logotype_header_1}`;
    } else {
      return '';
    }
  }

  colorBounce(): string {
    if(this.clientSetting) {
      return `${this.clientSetting?.clients_setting_global?.color_main_1}`;
    } else {
      return '';
    }
  }



}
